module.exports = __webpack_public_path__ + "static/media/action-e.a8f1ad0b.jpg";